import React from 'react'

import classNames from 'classnames'

import { StreamingNotes } from './StreamingNotesV2'
import { setDealAdvisorSubTab } from '@/client/generalSlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { DealNotes } from '@/features/SidePanel/DealNotes/DealNotesV2'
import { DelayReasonSection } from '@/features/SidePanel/DelayReasonSection'

export const Notes = ({ activeGroupObject }) => {
  const dispatch = useAppDispatch()
  const mode = useAppSelector((state) => state.general.dealAdvisorSubTabs.notes)

  const tabs = [
    { name: 'Streaming Notes', value: 'streaming' },
    { name: 'Deal Notes', value: 'deal' },
  ]

  return (
    <div>
      <div className='tabs tabs-bordered tab-border-2'>
        {tabs.map((tab) => (
          <a
            key={tab.value}
            className={classNames('tab', { 'tab-active': mode === tab.value })}
            onClick={() => dispatch(setDealAdvisorSubTab({ tab: 'notes', value: tab.value }))}
          >
            {tab.name}
          </a>
        ))}
      </div>

      {mode === 'deal' && (
        <>
          <DelayReasonSection checklistGroup={activeGroupObject} />
          <DealNotes />
        </>
      )}
      {mode === 'streaming' && <StreamingNotes />}
    </div>
  )
}
